import * as React from "react";
import ImageLoader from "react-load-image";
import ImageZoom from "react-medium-image-zoom";
import { LoadingGif } from "./GifLoaderStyles";
import { MEDIA_URL } from "static-content/RelativeUrlHelperFunctions";
import { fetchPanelApi } from "static-content/view/api";
import { getLanguage } from "../ahp-slider/AhpSlider";

export const GifLoader = (props) => {
  const panelApi = fetchPanelApi("COMMON");
  const alt = getAltTag(panelApi, props.alternative);
  if (props.src.endsWith('.svg')) {
    return (
      <embed
        src={props.src}
        height='100px'
        width='100px'
      />
    )
  }
  return (
    <ImageLoader src={props.src}>
      {renderImage(props, alt)}
      <React.Fragment />
      <LoadingGif>
        <img src={`${MEDIA_URL}/common/loading.gif`} alt={alt} />
      </LoadingGif>
    </ImageLoader>
  );
};

const renderImage = (props, alt) => {
  const translatedImgUrl = getTranslatedImg(props.src, alt);
  if (props.enlarge) {
    return (
      <ImageZoom
        image={{
          src: translatedImgUrl,
          alt: alt,
          className: "gif-view",
        }}
        onZoom={() => props.onClickImage(translatedImgUrl)}
        defaultStyles={{
          zoomContainer: { zIndex: 3000 },
          zoomImage: { zIndex: 3000 },
          overlay: { backgroundColor: "rgba(0, 0, 0, .6)" },
        }}
      />
    )
  }

  return <img className="gif-view" alt={alt} />;
};

const getAltTag = (panelApi, alternative) => {
  const alt = !panelApi ? "Image" : panelApi.get("LOADING_GIF");
  return alternative === undefined ? alt : alternative;
};

const getTranslatedImg = (url, alt) => {
  const splitUrl = alt.split("/");
  if (splitUrl.length === 1) return url;
  const lastUrlBlock = splitUrl[splitUrl.length - 1];
  const isMultiLanguage = lastUrlBlock.substring(lastUrlBlock.length - 9, lastUrlBlock.length - 4) === '_lang';
  splitUrl.splice(splitUrl.length - 1, 0, getLanguage());
  return isMultiLanguage ? splitUrl.join('/') : url
}
